'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccountWrapper = require('./AccountWrapper');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccountWrapper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }